import { render } from "./SorryButton.vue?vue&type=template&id=4a750f70&scoped=true"
import script from "./SorryButton.vue?vue&type=script&lang=js"
export * from "./SorryButton.vue?vue&type=script&lang=js"

import "./SorryButton.vue?vue&type=style&index=0&id=4a750f70&lang=stylus&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a750f70"]])

export default __exports__